module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    style: (_vm.style),
    attrs: {
      "id": "gv-header"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b5510d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 836
// module chunks = 39